export default [
  {
    name: 'QueryCarOrderDetail',
    method: 'get',
    desc: '用车订单详情查询接口',
    path: '/obt/QueryCarOrderDetail',
    params:{
      orderId:''
    }
  },
  {
    name: 'cancelCarOrder',
    method: 'get',
    desc: '取消用车订单接口',
    path: '/obt/cancelCarOrder',
    params:{
      orderId: '',
      qxbh:'',	// 取消原因id
      qxyy:'',	// 取消原因描述
      sfqx:''// 是否取消
    }
  },
  {
    name: 'orderList',
    method: 'post',
    desc: '用车订单列表管理',
    path: '/obt/vehicles/order/list',
    params: {
      'dateType': '',
      'dateStart': '',
      'dateEnd': '',
      'orderNo': '',
      'empName': '',
      'linkTel': '',
      'cityId': '',
      'orderType': 0,
      'findScope': '',//1是个人订单,2是全部订单
      'pageNum': 1,
      'count': 20
    }
  },
  {
    name: 'orderDetail',
    method: 'get',
    desc: '用车订单详情',
    path: '/obt/vehicles/order/detail',
    params: {
      orderId: ''
    }
  },
  {
    name: 'getDriverLocation',
    method: 'post',
    desc: '获取司机位置',
    path: '/obt/vehicles/order/getDriverLocation',
    loading:'0',
    params: {
      id: '',
      resultFlag: ''
    }
  },
  {
    name: 'getCancelFee',
    method: 'post',
    desc: '获取罚金',
    path: '/obt/vehicles/order/getCancelFee',
    params: {
      orderId:''
    }
  },
  {
    name: 'orderCancel',
    method: 'post',
    desc: '取消用车订单',
    path: '/obt/vehicles/order/cancel',
    params: {
      'orderId': '',
      'qxbh': 'string',// 取消原因编号 
      'qxyy': 'string',//取消原因描述
    }
  },
  {
    name: 'blztList',
    method: 'get',
    desc: '用车订单办理状态详情',
    path: '/obt/vehicles/order/blztList',
    params: {
      'orderId': '',
    }
  },
]
